import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const TriangleIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 9",
    fill: "currentColor",
    width: size || '6',
    height: size || '9'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 4.5L0 9V0z",
    fillRule: "evenodd"
  }));
};
TriangleIcon.displayName = 'TriangleIcon';
export default TriangleIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TriangleIcon.js.map